import { Link } from 'react-router-dom';
import { newReleases, trendingList, Article } from '@/mocks/movieData';

function NewsCard({ article }: { article: Article }) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group flex gap-3 p-3 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
    >
      <div className="relative w-28 md:w-36 shrink-0 rounded-md overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {article.badge && (
          <span className="absolute top-1 left-1 px-1.5 py-0.5 bg-accent-500 text-background-50 text-[10px] font-medium rounded whitespace-nowrap">
            {article.badge}
          </span>
        )}
      </div>
      <div className="flex flex-col justify-between min-w-0 flex-1">
        <div>
          <h3 className="text-sm font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
            {article.title}
          </h3>
          <p className="text-xs text-foreground-500 line-clamp-2 mt-1 leading-relaxed">
            {article.description}
          </p>
        </div>
        <div className="flex items-center gap-2 text-xs text-foreground-400">
          <span>{article.category}</span>
          <span>·</span>
          <span>{article.date}</span>
          <span className="flex items-center gap-0.5 text-accent-500 font-medium">
            <i className="ri-star-fill text-[10px]"></i>
            {article.rating}
          </span>
        </div>
      </div>
    </Link>
  );
}

function TrendingCard({ article, index }: { article: Article; index: number }) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group flex items-center gap-3 py-2.5 border-b border-background-200/70 last:border-b-0 cursor-pointer"
    >
      <span className={`w-6 h-6 flex items-center justify-center rounded text-xs font-bold shrink-0 ${
        index === 0 ? 'bg-accent-500 text-background-50' :
        index === 1 ? 'bg-primary-500 text-background-50' :
        index === 2 ? 'bg-secondary-500 text-background-50' :
        'bg-background-200 text-foreground-500'
      }`}>
        {index + 1}
      </span>
      <div className="min-w-0 flex-1">
        <h4 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-1">
          {article.title}
        </h4>
        <div className="flex items-center gap-2 text-xs text-foreground-400 mt-0.5">
          <span>{article.category}</span>
          <span className="flex items-center gap-0.5 text-accent-500 font-medium">
            <i className="ri-star-fill text-[10px]"></i>
            {article.rating}
          </span>
        </div>
      </div>
      <span className="text-xs text-foreground-400 shrink-0">{article.views}</span>
    </Link>
  );
}

export default function ContentSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                最新更新
              </h2>
              <Link to="/category/dianshiju" className="text-sm text-primary-500 font-medium flex items-center gap-1 cursor-pointer">
                更多 <i className="ri-arrow-right-s-line"></i>
              </Link>
            </div>
            <div className="flex flex-col divide-y divide-background-200/70">
              {newReleases.map((article) => (
                <NewsCard key={article.id} article={article} />
              ))}
            </div>
          </div>

          <div>
            <div className="bg-background-100 rounded-lg p-4 md:p-5 sticky top-20">
              <div className="flex items-center gap-2 mb-4">
                <i className="ri-fire-line text-accent-500 text-lg"></i>
                <h2 className="text-lg font-heading font-bold text-foreground-900">热门排行</h2>
              </div>
              <div className="flex flex-col">
                {trendingList.map((article, index) => (
                  <TrendingCard key={article.id} article={article} index={index} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}